import { useEffect } from "react";
import { GroundUpQuote } from "../quote";
import { observer } from "mobx-react";
import { useOneToolStore } from "../quote/hooks/useOneToolStore";
import { useParams } from 'react-router';

export const EditGroundUp = observer(() => {
  const { oneToolStore } = useOneToolStore();
  const { groundUpQuoteStore } = oneToolStore;
  const { loanId } = useParams<{ loanId: string }>();

  useEffect(() => {
    groundUpQuoteStore.loadQuoteToEdit(loanId);
  }, [groundUpQuoteStore, loanId]);

  return (<GroundUpQuote />);
});